import React from 'react';
import classnames from 'classnames';
import './index.scss';
import RenderGameIcon from '@op/components/RenderImg/renderGameIcon';
import { useGameOperations } from '@op/utils/game';
import SvgIcon from '@home/components/SvgIcon';
import { useIntl } from 'umi';
import moment from 'moment';
import BubbleCommon, { TipsMapType } from '@op/components/BubbleCommon';

type GameInfoItemProps = {
  className?: string;
  name?: string;
  item?: any;
  isCurrentGame?: boolean;
  showPlatform?: boolean;
  showReleaseDate?: boolean;
  extraContent?: React.ReactNode;
  nameTipsMap?: TipsMapType;
  children?: any;
};

const EntryTypeIconMap: { [key: string]: string } = {
  mobile: 'other-icon',
  pc: 'monitor',
  console: 'merit',
};

const GameInfoItem = (props: GameInfoItemProps) => {
  const {
    className,
    item,
    name,
    isCurrentGame,
    showPlatform = false,
    showReleaseDate = false,
    extraContent,
    nameTipsMap,
    children,
  } = props;

  const { handleChangeGame } = useGameOperations();
  const { formatMessage } = useIntl();

  return (
    <div className={classnames('dbo-game-info-item-wrapper', className)}>
      <RenderGameIcon
        gameInfo={item}
        className="dbo-game-icon"
      ></RenderGameIcon>
      <div className={'dbo-game-data'}>
        <BubbleCommon placement="top" showIcon={false} tipsMap={nameTipsMap}>
          <span
            onClick={(e) => {
              e.stopPropagation();
              handleChangeGame(item, true);
            }}
            className={classnames('dbo-game-name', {
              'dbo-game-name__current': isCurrentGame,
            })}
          >
            {name || item?.entity_name}
          </span>
        </BubbleCommon>
        <div className={'dbo-game-details'}>
          {showPlatform && item?.entity_type && (
            <SvgIcon
              className="dbo-game-platform-icon"
              type={EntryTypeIconMap[item.entity_type]}
            />
          )}
          {showReleaseDate && (
            <span
              className={classnames('dbo-game-release-date', '__dbo-border')}
            >
              {item?.release_time
                ? `${formatMessage({ id: 'Release Date' })}: ${moment(
                    item.release_time,
                  ).format('YYYY-MM-DD')}`
                : formatMessage({ id: 'Unreleased' })}
            </span>
          )}
          {children('__dbo-border')}
        </div>
        {extraContent}
      </div>
    </div>
  );
};

export default GameInfoItem;
